import styled, { css } from 'styled-components'
import { Box } from '@usap/uicomponents'

const applyPadding = (theme, paddingProp, size) => `
  ${paddingProp}: ${theme.global.edgeSize[size]};

  @media (max-width: 768px) {
    ${paddingProp}: ${theme.global.breakpoints.small.edgeSize[size]};
  }
`

const overlayAndFixedStyle = css`
  margin: 0 auto;
  z-index: 10;
  position: fixed;
  top: 50%;
  width: 100%;
  left: 0%;
  
  ${props => props.theme.mediaQuery.up('tablet-landscape')} {
    left: 50%;
    transform: translate(-50%, -50%);
  }
`

const withoutOverlayAndFixedStyle = css`
  position: relative;
  padding-bottom: ${props => (props.isHomePage ? '0px' : '16px')};
  margin-bottom: -28px;

  ${props => props.theme.mediaQuery.up('tablet-landscape')} {
    margin-bottom: ${props => (props.isHomePage ? '-38px' : '-6px')};
  }
`

const mobileOverlayStyle = css`
  ${props => props.theme.mediaQuery.down('tablet-landscape')} {
    position: absolute;
    top: 20px;
  }
`

const VehicleSelectorRoot = styled(Box)`
  margin: 0px;
  ${props => (props.isHomePage ? applyPadding(props.theme, 'padding-top', 'small') : '')}
  ${props => (props.overlay && props.positionRelative ? overlayAndFixedStyle : withoutOverlayAndFixedStyle)}
  ${props => props.shouldHide && 'display: none;'}
  ${props => props.overlay && mobileOverlayStyle}
  ${props => props.overlay && 'z-index: 10;'}
`

export default VehicleSelectorRoot
